import { FillLayerSpecification } from 'maplibre-gl';

import { AcresMapboxLayerIds, AcresMapboxSourceIds } from '..';

export const boundaryFillLayer: FillLayerSpecification = {
  id: AcresMapboxLayerIds.BOUNDARY,
  layout: {},
  paint: {
    'fill-color': '#FFE607',
    'fill-opacity': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      0.25,
      0,
    ],
  },
  source: AcresMapboxSourceIds.BOUNDARY_OUTLINE,
  type: 'fill',
};
